import React, { useState } from "react";
import {
    Box,
    Container,
    Dialog,
    IconButton,
    Typography,
} from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import CloseIcon from "@mui/icons-material/Close";
import Slider from "react-slick";
import { motion } from "framer-motion";
import { storiescoach } from "../../../../assets";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


const SlickSlider = Slider as unknown as React.FC<any>;

interface Testimonial {
    id: number;
    videoUrl: string;
}

const testimonials: Testimonial[] = [
    { id: 1, videoUrl: "https://dprstorage.b-cdn.net/rwWebinarVedios/video1.mp4" },
    { id: 2, videoUrl: "https://dprstorage.b-cdn.net/rwWebinarVedios/web1.mp4" },
    { id: 3, videoUrl: "https://dprstorage.b-cdn.net/rwWebinarVedios/video3.mp4" },
    { id: 4, videoUrl: "https://dprstorage.b-cdn.net/rwWebinarVedios/web4.mp4" },
    { id: 5, videoUrl: "https://dprstorage.b-cdn.net/rwWebinarVedios/video4.mp4" },
    { id: 6, videoUrl: "https://dprstorage.b-cdn.net/rwWebinarVedios/web2.mp4" },
    { id: 7, videoUrl: "https://dprstorage.b-cdn.net/rwWebinarVedios/video2.mp4" },
    { id: 8, videoUrl: "https://dprstorage.b-cdn.net/rwWebinarVedios/web3.mp4" },
    { id: 9, videoUrl: "https://dprstorage.b-cdn.net/rwWebinarVedios/video5.mp4" },
    // { id: 10, videoUrl: "https://dprstorage.b-cdn.net/rwWebinarVedios/web5.mp4" },


];
const NextArrow = (props: any) => {
    const { onClick } = props;
    return (
        <IconButton
            onClick={onClick}
            sx={{
                position: "absolute",
                right: "-20px",
                top: "45%",
                zIndex: 10,
                background: "#fff",
                color: "#0f63a5",
                "&:hover": { background: "#0c4e82" },
            }}
        >
            <ArrowForwardIosIcon />
        </IconButton>
    );
};

const PrevArrow = (props: any) => {
    const { onClick } = props;
    return (
        <IconButton
            onClick={onClick}
            sx={{
                position: "absolute",
                left: "-20px",
                top: "45%",
                zIndex: 10,
                background: "#fff",
                color: "#0f63a5",
                "&:hover": { background: "#0c4e82" },
            }}
        >
            <ArrowBackIosNewIcon />
        </IconButton>
    );
};

const VideoTestimonials: React.FC = () => {
    const [open, setOpen] = useState(false);
    const [activeVideo, setActiveVideo] = useState("");

    const handleOpen = (video: string) => {
        setActiveVideo(video);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setActiveVideo("");
    };

    // Slick Settings
    const settings = {
        dots: true,
        infinite: true,
        speed: 600,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: true,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        cssEase: "ease-in-out",
        centerMode: false,
        variableWidth: false,
        responsive: [
            {
                breakpoint: 1200,
                settings: { slidesToShow: 3 },
            },
            {
                breakpoint: 900,
                settings: { slidesToShow: 2 },
            },
            {
                breakpoint: 600,
                settings: { slidesToShow: 1 },
            },
        ],
    };
    return (
        <Box
            sx={{
                py: 8,
                backgroundImage: `
          linear-gradient(rgba(15,99,165,0.9), rgba(15,99,165,0.9)),
          url(${storiescoach})
        `,
                backgroundSize: "cover",
                backgroundPosition: "center",
                 display: "flex",                 // 🔥 IMPORTANT
    alignItems: "center",           // 🔥 VERTICAL CENTER
    justifyContent: "center",
                // height:{xs:'auto',md:'100vh'}


            }}
        >
            <Container maxWidth="lg">
                <Box textAlign="center" mb={6} color="white">
                    <Typography variant="h2" fontWeight={700} sx={{ color: 'white' }}>
                        Success Stories
                    </Typography>
                    <Typography sx={{ opacity: 0.8, color: 'white' }}>
                        Hear From Our trainees
                    </Typography>
                </Box>

                <Box
                    sx={{
                        px: { xs: 2, md: 4 },
                        position: "relative",
                        "& .slick-list": {
                            overflow: "hidden",

                        },
                        "& .slick-slide": {
                            padding: "0 10px",
                            boxSizing: "border-box",

                        },
                        "& .slick-dots li button:before": {
                            color: "#fff",
                            fontSize: "10px",
                        },
                        "& .slick-dots li.slick-active button:before": {
                            color: "#5e5e5f",
                        },
                    }}
                >


                    <SlickSlider {...settings}>
                        {testimonials.map((item) => (
                            <Box key={item.id} >
                                {/* <motion.div whileHover={{ y: -10 }}> */}
                                <Box
                                    sx={{
                                        position: "relative",
                                        borderRadius: "20px",
                                        overflow: "hidden",
                                        cursor: "pointer",
                                        // boxShadow: "0 25px 60px rgba(0,0,0,0.5)",
                                    }}
                                >
                                    <video
                                        src={item.videoUrl}
                                        muted
                                        loop
                                        playsInline
                                        style={{
                                            width: "100%",
                                            height: "400px",
                                            objectFit: "cover",
                                            display: "block",
                                        }}
                                    />

                                    <Box
                                        sx={{
                                            position: "absolute",
                                            inset: 0,
                                            transition: "0.3s",
                                            "&:hover": {
                                                background:
                                                    "linear-gradient(rgba(15,99,165,0.6), rgba(15,99,165,0.6))",
                                            },
                                        }}
                                    >
                                        <IconButton
                                            onClick={() => handleOpen(item.videoUrl)}
                                            sx={{
                                                position: "absolute",
                                                bottom: 16,
                                                right: 16,
                                                // backgroundColor: "#fff",
                                                width: 55,
                                                height: 55,
                                                boxShadow: "0 10px 25px rgba(0,0,0,0.4)",
                                                "&:hover": {
                                                    transform: "scale(1.1)",
                                                    backgroundColor: "#0f63a5",
                                                },
                                            }}
                                        >
                                            <PlayArrowIcon sx={{ color: "#fff", fontSize: 35 }} />
                                        </IconButton>
                                    </Box>
                                </Box>
                                {/* </motion.div> */}
                            </Box>
                        ))}
                    </SlickSlider>


                </Box>
            </Container>

            {/* Popup */}
            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth
                maxWidth={false}
                PaperProps={{
                    sx: { background: "transparent", boxShadow: "none" },
                }}
                BackdropProps={{
                    sx: {
                        backgroundColor: "rgba(0,0,0,0.7)",
                        backdropFilter: "blur(6px)",
                    },
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100vh",
                    }}
                >
                    {activeVideo && (
                        <Box
                            sx={{
                                position: "relative",   // IMPORTANT
                            }}
                        >
                            {/* Close Button */}
                            <IconButton
                                onClick={handleClose}
                                sx={{
                                    position: "absolute",
                                    top: 10,
                                    right: 10,
                                    zIndex: 10,
                                    backgroundColor: "rgba(0,0,0,0.6)",
                                    color: "#fff",
                                    "&:hover": {
                                        backgroundColor: "rgba(0,0,0,0.8)",
                                    },
                                }}
                            >
                                <CloseIcon />
                            </IconButton>

                            {/* Video */}
                            <motion.video
                                initial={{ scale: 0.8, opacity: 0 }}
                                animate={{ scale: 1, opacity: 1 }}
                                transition={{ duration: 0.4 }}
                                src={activeVideo}
                                controls
                                autoPlay
                                style={{
                                    height: "500px",
                                    maxWidth: "90vw",
                                    borderRadius: "20px",
                                    boxShadow: "0 40px 100px rgba(0,0,0,0.7)",
                                }}
                            />
                        </Box>
                    )}
                </Box>
            </Dialog>
        </Box>
    );
};

export default VideoTestimonials;